export default __webpack_public_path__ + "static/media/home-icon.ed729a54.svg";